import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

import { LabeledValue } from "../components";

import type { CarrierDetails, CarrierRepList } from "../types";

const EMPTY_VALUE = "—";
const LAST_EDITED_FORMAT: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
};

interface CarrierDetailHeaderProps {
  name: string;
  details: CarrierDetails;
  repList: CarrierRepList | null;
}

const formatLastEdited = (lastEditedAt: string | null): string =>
  lastEditedAt
    ? new Date(lastEditedAt).toLocaleDateString("en-US", LAST_EDITED_FORMAT)
    : EMPTY_VALUE;

export const CarrierDetailHeader = ({
  name,
  details,
  repList,
}: CarrierDetailHeaderProps): React.JSX.Element => {
  const fields = [
    { label: "RFPs in Extract", value: details.rfpsInExtract.toLocaleString() },
    { label: "Active Reps", value: repList?.activeRepsCount ?? EMPTY_VALUE },
    { label: "Rules", value: details.rules },
    { label: "Group", value: details.group },
    {
      label: "Last Edited",
      value: repList ? formatLastEdited(repList.lastEditedAt) : EMPTY_VALUE,
    },
  ];

  return (
    <Box display="flex" flexDirection="column" gap={1} p={2}>
      <Typography variant="header-medium" component="h2">
        {name}
      </Typography>
      <Box display="flex" gap={2}>
        {fields.map(({ label, value }) => (
          <LabeledValue key={label} label={label} value={value} />
        ))}
      </Box>
    </Box>
  );
};
